export const REGEX = {
	EMAIL: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
	DATE: /^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}$/,
	NAME: /^[^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,255}$/,
	NUMBER: /^\d+$/,
	PHONE: /^(?:\+?\d{1,3}[-.\s]?)?(?:\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}$/,
	SIX_DIGITS: /^\d{6}$/,
	STRING_WITH_NUMBERS: /^[^_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,255}$/,
	TEXT: /^[^_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,1000}$/,
  TEXT_SYMBOLS: /^[^_¡÷¿/\\+=#%ˆ&*{}|~<>[\]]{1,12000}$/,
  URL: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*|^(mailto|tel):[^\s]+$/,
	ODQEMAIL: /^([\w-\.]+@(odq\.qc\.ca|farpodq\.org|boitebeet\.com))$/i,
	WYSIWYG: /^[\s\S]{1,12000}$/,
	DATE2NUMBERS: /^([0-9]{2})$/,
	DATE4NUMBERS: /^([0-9]{4})$/,
}
